// export const GET_ALL_CUSTOM_PROVIDERS_ENDPOINT =
//   'https://api.reclaimprotocol.org/get/custom-providers'

import { FontOption } from './types';
import { getApiUrl, getBlueCheckApiUrl } from './utils';

export const GET_ALL_CUSTOM_PROVIDERS_ENDPOINT = `${getApiUrl()}/get/custom-providers`;

// export const GET_ALL_COMMUNITY_PROVIDERS_ENDPOINT =
// 	'https://api.reclaimprotocol.org/get/httpsproviders'

export const GET_ALL_COMMUNITY_PROVIDERS_ENDPOINT = `${getApiUrl()}/get/httpsproviders`;

export const DOCS_LINKS = [
  {
    name: 'NodeJS',
    icon: 'https://docs.reclaimprotocol.org/assets/icons/node.svg',
    docsLink: 'https://docs.reclaimprotocol.org/node',
  },
  {
    name: 'React',
    icon: 'https://docs.reclaimprotocol.org/assets/icons/reactjs.svg',
    docsLink: 'https://docs.reclaimprotocol.org/react',
  },
  {
    name: 'React Native',
    icon: 'https://docs.reclaimprotocol.org/assets/icons/react_native.svg',
    docsLink: 'https://docs.reclaimprotocol.org/react-native',
  },
  {
    name: 'Flutter',
    icon: 'https://docs.reclaimprotocol.org/assets/icons/flutter.svg',
    docsLink: 'https://docs.reclaimprotocol.org/flutter/quickstart',
  },
  {
    name: 'Solidity',
    icon: 'https://docs.soliditylang.org/en/latest/_static/img/logo-dark.svg',
    docsLink: 'https://docs.reclaimprotocol.org/solidity',
  },
  {
    name: 'Solana',
    icon: 'https://solana.com/_next/static/media/solanaLogoMark.17260911.svg',
    docsLink: 'https://docs.reclaimprotocol.org/solana',
  },
];

// API ENDPOINTS

// USERS
export const LOGIN = `${getApiUrl()}/api/users/login`;
export const GET_ALL_USERS = `${getApiUrl()}/api/users/all-users`;

// APPLICATIONS
export const GET_USER_APPLICATIONS = `${getApiUrl()}/api/applications`;
export const GET_SIGNED_URL_FOR_APPLICATION_LOGO = `${getApiUrl()}/api/applications/get-upload-url`;
export const GET_USER_APPLICATIONS_WITH_PAGINATION = `${getApiUrl()}/api/applications/paginated`;
export const GET_USER_ZK_FETCH_APPLICATIONS_WITH_PAGINATION = `${getApiUrl()}/api/zkfetch/paginated`;
export const APPLICATION_BY_ID = (id: string) => `${getApiUrl()}/api/applications/${id}`;
export const REGISTER_APPLICATION = `${getApiUrl()}/api/applications`;
export const REGISTER_NEW_APPLICATION = `${getApiUrl()}/api/applications/register`;
export const GET_PROVIDERS_BY_APPLICATION_ID = (id: string) =>
  `${getApiUrl()}/api/applications/providers/${id}`;
export const EDIT_APPLICATION = (id: string) =>
  `${getApiUrl()}/api/applications/edit/${id}`;
export const DELETE_APPLICATION = (id: string) => `${getApiUrl()}/api/applications/${id}`;

// ZKFETCH APPLICATIONS
export const ZKFETCH_APPLICATION = `${getApiUrl()}/api/zkfetch`;
export const ZKFETCH_APPLICATION_BY_ID = (id: string) =>
  `${getApiUrl()}/api/zkfetch/${id}`;

// PROVIDERS
export const REGISTER_PROVIDER = `${getApiUrl()}/api/providers/register`;
export const EDIT_PROVIDER = (id: string) => `${getApiUrl()}/api/providers/${id}`;
export const SAVE_PROVIDER_NETWORK_REQUEST_DATA = (id: string) =>
  `${getApiUrl()}/api/providers/${id}/network-request`;
export const GET_PROVIDER_NETWORK_REQUEST_DATA = (id: string) =>
  `${getApiUrl()}/api/providers/${id}/network-request`;
export const GET_ALL_ACTIVE_PROVIDERS = `${getApiUrl()}/api/providers/active`;
export const GET_PROVIDERS_WITH_PAGINATION = `${getApiUrl()}/api/providers/active/paginated`;
export const GET_PRIVATE_PROVIDERS_BY_USER_WITH_PAGINATION = `${getApiUrl()}/api/providers/private/user/paginated`;
export const GET_ALL_PROVIDERS_BY_USER_WITH_PAGINATION = `${getApiUrl()}/api/providers/user/paginated`;
export const GET_ALL_EXPLORE_PROVIDERS_WITH_PAGINATION = `${getApiUrl()}/api/providers/explore/paginated`;
export const GET_ALL_INACTIVE_PROVIDERS = `${getApiUrl()}/api/providers/inactive`;
export const GET_ALL_INACTIVE_PROVIDERS_WITH_PAGINATION = `${getApiUrl()}/api/providers/inactive/paginated`;
export const GET_ALL_PROVIDERS_WITH_MANUAL_VERIFICATION = `${getApiUrl()}/api/providers/manual-verification`;
export const GET_ALL_PROVIDERS_WITH_PAGINATION = `${getApiUrl()}/api/providers/all/paginated`;
export const GET_APPROVED_PROVIDERS_BY_USER = (userId: string) =>
  `${getApiUrl()}/api/providers/approved/${userId}`;
export const GET_PENDING_PROVIDERS_BY_USER = (userId: string) =>
  `${getApiUrl()}/api/providers/pending/${userId}`;
export const GET_ALL_PENDING_PROVIDERS = `${getApiUrl()}/api/providers/pending`;
export const GET_PROVIDER_BY_ID = (id: string) => `${getApiUrl()}/api/providers/${id}`;
export const GET_ALL_PROVIDER_CREATED_BY_USER = `${getApiUrl()}/api/providers/user`;
export const APPROVE_PROVIDER = (id: string) =>
  `${getApiUrl()}/api/providers/approve/${id}`;
export const VERIFY_PROVIDER = (id: string) =>
  `${getApiUrl()}/api/providers/verify/${id}`;
export const UNVERIFY_PROVIDER = (id: string) =>
  `${getApiUrl()}/api/providers/unverify/${id}`;
export const PRIVATE_PROVIDERS_BY_USER = `${getApiUrl()}/api/providers/user/private-providers`;
export const GET_ALL_PRIVATE_PROVIDERS = `${getApiUrl()}/api/providers/all/private-providers`;
export const GET_ALL_PRIVATE_PROVIDERS_WITH_PAGINATION = `${getApiUrl()}/api/providers/private-providers/paginated`;
export const UPDATE_OVERSEER = `${getApiUrl()}/api/providers/overseer`;
export const GET_POINTS_OF_INTEREST = `${getApiUrl()}/api/analyze-content/get-points-of-interest`;

// CHAT GPT
export const CHAT_GPT = `${getApiUrl()}/api/utils/chatGPT`;

// SLACK ALERT
export const SLACK_ALERT = `${getApiUrl()}/api/utils/slack-alert`;

// Log Search Queries
export const LOG_SEARCH_QUERY_API = `${getApiUrl()}/api/logger/search`;

// Manual Verification Sessions
export const GET_ALL_MANUAL_VERIFICATION_SESSIONS = (appId: string, queryType: string) =>
  `${getApiUrl()}/api/manual-verification/${appId}/sessions?type=${queryType}`;
export const UPDATE_MANUAL_VERIFICATION_SESSION = (sessionId: string) =>
  `${getApiUrl()}/api/manual-verification/session/${sessionId}`;
export const UPDATE_SESSION_V2 = `${getApiUrl()}/api/sdk/update/session`;
export const GET_MANUAL_VERIFICATION_SESSION_DATA = (sessionId: string) =>
  `${getApiUrl()}/api/manual-verification/session/${sessionId}`;
export const RETRY_MANUAL_VERIFICATION_WEBHOOK = (sessionId: string) =>
  `${getApiUrl()}/api/manual-verification/session/${sessionId}/retry-webhook`;
export const GET_MANUAL_VERIFICATION_CAPTURED_NETWORK_REQUESTS = (sessionId: string) =>
  `${getApiUrl()}/api/manual-verification/session/${sessionId}/network-requests`;
export const GET_MANUAL_VERIFICATION_PROVIDER_VERIFICATION_URL = `${getApiUrl()}/api/sdk/get-provider-verify-url`;
export const CREATE_MANUAL_VERIFIFCATION_CLAIM = (providerId: string) =>
  `${getApiUrl()}/api/manual-verification/${providerId}/create-claim`;

// NOTIFICATIONS
export const FETCH_ALL_NOTIFICATIONS = `${getApiUrl()}/api/notifications`;

// FEATURE FLAGS
export const GET_FEATURE_FLAGS = `${getApiUrl()}/api/feature-flags/get?`;
export const CREATE_FEATURE_FLAGS = `${getApiUrl()}/api/feature-flags/create`;
export const GET_ALL_FEATURE_FLAGS = `${getApiUrl()}/api/feature-flags/get-all`;
export const DELETE_FEATURE_FLAG = (flagName: string) =>
  `${getApiUrl()}/api/feature-flags/delete/${flagName}`;

// OWNER DETAILS
export const GET_OWNER_DETAILS = (searchedId: string, searchType: string) =>
  `${getApiUrl()}/api/utils/get-owner-details?searchedId=${searchedId}&searchType=${searchType}`;

// USER DETAILS
export const SEARCH_USERS = (searchedUserQuery: string) =>
  `${getApiUrl()}/api/utils/search-users?searchTerm=${searchedUserQuery}`;
export const GET_USER_DETAILS = (userId: string) =>
  `${getApiUrl()}/api/utils/get-user-details?userId=${userId}`;

// BLUECHECK APPLICATIONs
export const GET_ALL_BLUECHECK_APPLICATIONS = `${getBlueCheckApiUrl()}/applications`;
export const CREATE_BLUECHECK_APPLICATION = `${getBlueCheckApiUrl()}/applications`;
export const GET_BLUECHECK_APPLICATION_BY_ID = (id: string) =>
  `${getBlueCheckApiUrl()}/applications/${id}`;
export const DELETE_BLUECHECK_APPLICATION = (id: string) =>
  `${getBlueCheckApiUrl()}/applications/${id}`;
export const UPDATE_BLUECHECK_APPLICATION = (id: string) =>
  `${getBlueCheckApiUrl()}/applications/${id}`;
// Check if Application name exists
export const CHECK_APPLICATION_NAME_EXISTS = (name: string) =>
  `${getBlueCheckApiUrl()}/applications/check-metadata-name?name=${name}`;

export const FONT_OPTIONS: FontOption[] = [
  { value: 'Inter', label: 'Inter' },
  { value: 'Hahmlet', label: 'Hahmlet' },
  { value: 'Roboto', label: 'Roboto' },
  { value: 'Arial', label: 'Arial' },
  { value: 'Helvetica', label: 'Helvetica' },
];
